import SignupPopupMain from './Main';
import SignupPopupSuccess from './Success';
import { useGlobal } from '@/utils/useGlobal';

export default function SignupPopup() {
    const { useState } = useGlobal();
    // 1: popup 留邮箱 2 popup 成功success
    const [statu, setStatu] = useState(1);
    return (
        <div className="signup-popup">
            <SignupPopupMain changeStatu={setStatu} />
            {statu === 2 && <SignupPopupSuccess changeStatu={setStatu} />}
        </div>
    );
}
